<template>
  <v-dialog v-model="dialog" width="720" persistent no-click-animation scrollable>
    <v-card class="pa-0">
      <v-card-title class="pa-0">
        <v-toolbar flat height="55">
          <v-toolbar-title class="subtitle-1 text--secondary font-weight-medium">Crear comprobante de cancelación</v-toolbar-title>
          <v-spacer />
          <v-toolbar-items>
            <v-row align="center" justify="center" class="mr-1">
              <v-btn class="ml-3" @click="dialog=false" icon small><v-icon size="24">mdi-close</v-icon></v-btn>
            </v-row>
          </v-toolbar-items>
        </v-toolbar>
      </v-card-title>
      <v-divider />
      <v-card-text class="pa-0 pt-3 background">
        <v-list class="transparent">
          <v-list-item class="py-0">
            <v-list-item-title class="text-left">Total a cancelar</v-list-item-title>
            <v-list-item-subtitle class="text-right">{{invoice.total | currency(invoice.currency)}} {{invoice.currency}}</v-list-item-subtitle>
          </v-list-item>
          <v-list-item class="py-0">
            <v-list-item-title class="text-left">Total de la factura</v-list-item-title>
            <v-list-item-subtitle class="text-right">{{invoice.total | currency(invoice.currency)}} {{invoice.currency}}</v-list-item-subtitle>
          </v-list-item>
          <v-list-item class="py-0 mt-4">
            <v-list-item-title class="text-left body-1 text--secondary font-weight-medium">Total de la factura ajustada</v-list-item-title>
            <v-list-item-subtitle class="text-right body-1 font-weight-medium">0 {{invoice.currency}}</v-list-item-subtitle>
          </v-list-item>
        </v-list>

        <v-divider class="my-3" />

        <v-list class="v-list-form transparent">
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title>
                <span class="mr-3 text--secondary font-weight-medium">Fecha</span>
              </v-list-item-title>
              <v-list-item-subtitle>
                <v-row class="mx-0">
                  <v-col cols="6">
                    <v-menu v-model="dateMenu" :close-on-content-click="false" offset-y transition="scale-transition" max-width="280px">
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field v-model="$v.creditNote.date.$model" :error="$v.creditNote.date.$error" v-bind="attrs" v-on="on" background-color="white" outlined single-line dense readonly hide-details>
                          <template v-slot:append>
                            <v-icon class="mr-3" size="20px" color="secondary">mdi-calendar</v-icon>
                          </template>
                        </v-text-field>
                      </template>
                      <v-date-picker v-model="$v.creditNote.date.$model" no-title @input="dateMenu=false" color="indigo" :first-day-of-week="1" locale="es-cl" :min="invoice.date" :max="today" type="date" width="280">
                        <div class="mx-auto">
                          <v-btn color="primary" @click="() => {$v.creditNote.date.$model = today}">Hoy</v-btn>
                          <v-btn class="ml-2" outlined @click="() => {$v.creditNote.date.$model = ''}">Limpiar</v-btn>
                        </div>
                      </v-date-picker>
                    </v-menu>
                  </v-col>
                </v-row>
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title>
                <span class="mr-3 text--secondary font-weight-medium">Motivo de cancelación</span>
                <v-tooltip right max-width="280px" transition="scale-transition">
                  <template v-slot:activator="{ on }">
                    <v-icon v-on="on" small color="secondary">mdi-information</v-icon>
                  </template>
                  <span>Motivo que justifica la cancelación del CFDI ante el SAT</span>
                </v-tooltip>
              </v-list-item-title>
              <v-list-item-subtitle>
                <v-select v-model="$v.creditNote.tax_settings.mx_cancellation_motive.$model" :error="$v.creditNote.tax_settings.mx_cancellation_motive.$error" dense flat :items="mxCancellationMotives" item-text="name" item-value="id" hide-details outlined solo />
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <v-list-item v-if="creditNote.tax_settings.mx_cancellation_motive === '01'">
            <v-list-item-content>
              <v-list-item-title>
                <span class="mr-3 text--secondary font-weight-medium">UUID del CFDI que sustituye <v-chip color="defaultGrey" text-color="secondary" small>Opcional</v-chip></span>
                <v-tooltip right max-width="280px" transition="scale-transition">
                  <template v-slot:activator="{ on }">
                    <v-icon v-on="on" small color="secondary">mdi-information</v-icon>
                  </template>
                  <span>UUID del nuevo CFDI que reemplaza al que se está cancelando.</span>
                </v-tooltip>
              </v-list-item-title>
              <v-list-item-subtitle>
                <v-text-field v-model="$v.creditNote.tax_settings.mx_substitution_uuid.$model" :error="$v.creditNote.tax_settings.mx_substitution_uuid.$error" background-color="white" outlined hide-details single-line dense maxlength="64" placeholder="00000000-0000-0000-0000-000000000000" />
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title>
                <span class="mr-3 text--secondary font-weight-medium">Nota interna <v-chip color="defaultGrey" text-color="secondary" small>Opcional</v-chip></span>
                <v-tooltip right max-width="280px" transition="scale-transition">
                  <template v-slot:activator="{ on }">
                    <v-icon v-on="on" small color="secondary">mdi-information</v-icon>
                  </template>
                  <span>Utiliza este campo para proveer información adicional sobre la cancelación. Esto no será visible para tu cliente.</span>
                </v-tooltip>
              </v-list-item-title>
              <v-list-item-subtitle>
                <v-textarea v-model="$v.creditNote.internal_note.$model" :error="$v.creditNote.internal_note.$error" background-color="white" outlined hide-details required maxlength="512" />
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-card-text>
      <v-divider />
      <v-card-actions class="pa-4">
        <v-spacer />
        <v-btn @click="dialog=false" outlined color="secondary">Cancelar</v-btn>
        <v-btn @click="create" :loading="createLoader" color="primary">Crear comprobante de cancelación</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { mapState } from 'vuex'
import { maxLength, required } from 'vuelidate/lib/validators'

import CreateViewMixin from '@/mixins/CreateViewMixin'
import TaxAgencyViewMixin from '@/mixins/TaxAgencyViewMixin'

export default {
  mixins: [
    CreateViewMixin,
    TaxAgencyViewMixin
  ],
  data: () => ({
    createLoader: false,
    creditNote: {
      date: '',
      internal_note: '',
      tax_settings: {
        mx_cancellation_motive: '02',
        mx_substitution_uuid: ''
      }
    },
    dateMenu: false,
    dialog: false,
    mxCancellationMotives: [
      { id: '01', name: 'Comprobante emitido con errores con relación' },
      { id: '02', name: 'Comprobante emitido con errores sin relación' },
      { id: '03', name: 'No se llevó a cabo la operación' },
      { id: '04', name: 'Operación nominativa relacionada en una factura global' }
    ]
  }),
  computed: {
    handledErrors () {
      return this.baseHandledErrors.concat([
        {
          action: 'Cargar folios',
          message: 'La cuenta no tiene un folio válido para Nota de crédito.',
          route: { name: 'BillersBuiltIn', query: { ref: 'folios' } },
          snippet: 'not have a valid folio'
        }
      ])
    },
    ...mapState({
      invoice: state => state.invoices.invoicesDetail
    })
  },
  watch: {
    dialog: {
      handler (newValue) {
        this.$emit('update:dialog', newValue)
      }
    },
    showCreate: {
      handler (newValue) {
        if (newValue) {
          this.dialog = true
        } else {
          this.dialog = false
        }
      }
    }
  },
  methods: {
    create () {
      this.$v.creditNote.$touch()

      if (this.$v.creditNote.$invalid) {
        return false
      }

      this.$dialog.warning({
        title: 'Crear comprobante de cancelación',
        text: `
          <span class="d-block mb-4">Al continuar se</span>
          <span class="d-block pl-6">1. Cancelará la factura por el total de ${this.$options.filters.currency(this.invoice.total, this.invoice.currency)} ${this.invoice.currency}</span>
          <span class="d-block pl-6">2. Enviará la solicitud de cancelación a la agencia fiscal de ${this.account.country.name}</span>
          <span class="d-block my-4">¿Estás seguro de continuar?</span>
          <span class="d-block font-weight-medium">Esta acción no se puede deshacer</span>
        `,
        actions: [
          {
            color: 'primary',
            text: 'Crear comprobante de cancelación',
            handle: () => {
              this.createLoader = true

              const taxSettings = {
                mx_cancellation_motive: this.creditNote.tax_settings.mx_cancellation_motive
              }
              if (taxSettings.mx_cancellation_motive === '01' && this.creditNote.tax_settings.mx_substitution_uuid) {
                taxSettings.mx_substitution_uuid = this.creditNote.tax_settings.mx_substitution_uuid
              }

              const payload = {
                date: this.creditNote.date,
                invoice: this.invoice.id,
                document: 'MX23',
                internal_note: this.creditNote.internal_note,
                tax_settings: taxSettings
              }

              this.$store.dispatch('invoices/CREATE', {
                resource: 'creditnotes',
                payload,
                commitInstance: false
              })
              .then((response) => {
                this.$store.dispatch('invoices/RETRIEVE', {
                  resource: 'creditnotes',
                  detail: 'finalize',
                  id: response.data.id,
                  loader: false,
                  setDetail: false
                })
                .then((response) => {
                  this.dialog = false
                  this.$emit('update:create')
                  this.$router.push({
                    name: 'CreditNoteRetrieve',
                    params: {
                      id: response.data.id
                    }
                  })
                })
                .catch((error) => {
                  this.$store.dispatch('invoices/DESTROY', {
                    resource: 'creditnotes',
                    id: response.data.id,
                    commitInstance: false
                  })
                  const errorData = error.response.data
                  if (errorData.non_field_errors) {
                    const handledError = this.handledErrors.find(he => errorData.non_field_errors.includes(he.snippet))
                    if (handledError) {
                      this.$dialog.message.error(handledError.message, {
                        timeout: 10000,
                        actions: [{
                          text: handledError.action,
                          color: 'red darken-4',
                          handle: () => {
                            if (handledError.route) {
                              const routerData = this.$router.resolve(handledError.route)
                              window.open(routerData.href, '_blank')
                            }
                          }
                        }]
                      })
                    } else {
                      this.$dialog.message.error(this.parseErrors(error.response.data))
                    }
                  } else {
                    this.$dialog.message.error(this.parseErrors(error.response.data))
                  }
                })
                .finally(() => {
                  this.createLoader = false
                })
              })
              .catch((error) => {
                this.$dialog.message.error(this.parseErrors(error.response.data))
                this.createLoader = false
              })
            }
          }
        ]
      })
    }
  },
  validations: {
    creditNote: {
      date: {
        required
      },
      internal_note: {
        maxLength: maxLength(1024)
      },
      tax_settings: {
        mx_cancellation_motive: {
          required
        },
        mx_substitution_uuid: {
          maxLength: maxLength(64)
        }
      }
    }
  }
}
</script>
